import { Close, PriorityHigh } from "@mui/icons-material";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { Box, FormControlLabel, Switch } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  useDeleteMediaMutation,
  useGetMediaMutation,
  useUpdateMediaMutation,
  useUploadImageMutation,
} from "../../../../redux/slices/postEditorBlogSlice";
import { toast } from "react-toastify";
import { useWebSocket } from "../../../../contexts/WebSocketContext";
import CustomLoader from "../../../CustomLoader";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
export const ImageUploadModal = ({
  formikValues,
  handleImageModal,
  handleSetImage,
  editor,
  isEdit,
  editImageUrl,
}) => {
  const { t } = useTranslation();
  const [value, setValue] = useState(1);
  const handleClose = () => {
    handleImageModal();
  };
  const { uploadingState } = useWebSocket();
  const [getMedia, { isLoading: loadingMedia }] = useGetMediaMutation();
  const [uploadImage, { isLoading: imageUploading }] = useUploadImageMutation();
  const [deleteImage, { isLoading: deleting }] = useDeleteMediaMutation();
  const [updateMedia, { isLoading: updating }] = useUpdateMediaMutation();
  const [media, setMedia] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [dragOver, setDragOver] = useState(false);
  const [image, setImage] = useState(null);
  const [imageForUpload, setImageForUpload] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [seoOptimization, setSeoOptimization] = useState(false);
  const [genFileName, setGenFileName] = useState(false);
  const [genAltText, setGenAltText] = useState(false);
  const [genLegend, setGenLegend] = useState(false);
  const [compressImage, setCompressImage] = useState(false);
  const [imageSize, setImageSize] = useState(1600);
  const [hasImageSize, setHasImageSize] = useState(false);
  const [toWebp, setToWebp] = useState(false);
  const [open, setOpen] = useState(false);
  const [editAltText, setEditAltText] = useState("");
  const [editTitle, setEditTitle] = useState("");
  const [editLegend, setEditLegend] = useState("");
  const [editDescription, setEditDescription] = useState("");
  const [aboutImg, setAboutImg] = useState("");
  const loadMedia = async () => {
    try {
      setImage(null);
      const response = await getMedia().unwrap();
      let media = response?.media;
      if (isEdit) {
        let item = media.find((item) => item.url == editImageUrl);
        if (item) {
          media = [item];
          handleViewImage(item);
        } else {
          media = [];
        }
      }
      setMedia(media);
    } catch (error) {
      toast.error(t(error));
    }
  };
  const handleChange = (newValue) => {
    if (newValue === 1) {
      loadMedia();
    } else {
      setImage(null);
    }
    setValue(newValue);
  };
  const tabs = [
    { name: t("media-library", "Media Library"), value: 1 },
    { name: t("Upload Image", "Upload Image"), value: 2 },
  ];
  const handleDeleteImage = async () => {
    try {
      let payload = {
        id: image?.id,
      };
      setImage(null);
      setOpen(false);
      const response = await deleteImage(payload).unwrap();
      if (response?.status == 200) {
        toast.success(t(response?.detail));
        editor.commands.command(({ tr, state, dispatch }) => {
          const { doc } = state;
          let modified = false;

          doc.descendants((node, pos) => {
            if (node.type.name === "image" && node.attrs.src === image?.url) {
              tr.delete(pos, pos + node.nodeSize);
              modified = true;
            }
          });

          if (modified && dispatch) {
            dispatch(tr);
            return true;
          }

          return false;
        });
        handleChange(1);
      } else {
        toast.error(t(response.detail));
      }
    } catch (error) {
      setOpen(false);
      toast.error(t(error));
    }
  };
  const handleUpdate = async () => {
    try {
      let payload = {
        id: image?.id,
        alt_text: editAltText,
        caption: editLegend,
        description: editDescription,
        title: editTitle,
        isEdit: isEdit,
      };
      setImage(null);
      const response = await updateMedia(payload).unwrap();
      if (response?.status == 200) {
        setImage(response?.data);
      } else {
        toast.error(t(response.detail));
      }
    } catch (error) {
      toast.error(t(error.error));
    }
  };
  const handleDeleteModal = (open = true) => {
    if (open) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  };

  const fileInputRef = useRef(null);
  const handleUpload = async () => {
    try {
      if (hasImageSize && (!imageSize || imageSize === 0)) {
        setUploading(false);
        toast.error(t("please-enter-valid-size", "Please Enter a valid size"));
      }
      const formData = new FormData();
      formData.append("file", imageForUpload);
      formData.append("blogId", formikValues?.id);
      formData.append("genFileName", genFileName);
      formData.append("genAltText", genAltText);
      formData.append("genLegend", genLegend);
      formData.append("compressImage", compressImage);
      formData.append("hasImageSize", hasImageSize);
      formData.append("imageSize", imageSize);
      formData.append("toWebp", toWebp);
      formData.append("description", aboutImg);
      const response = await uploadImage(formData).unwrap();
      if (response?.status == 200) {
      } else {
        toast.error(t(response.detail));
      }
      setUploading(false);
      setPreviewUrl(false);
      setImageForUpload(null);
      setSeoOptimization(false);
      setGenFileName(false);
      setGenAltText(false);
      setGenLegend(false);
      setHasImageSize(false);
      setImageSize(1600);
      setCompressImage(false);
      setToWebp(false);
      handleChange(1);
      handleViewImage(response.data);
      //   handleSetImage(response?.url);
    } catch (error) {
      setUploading(false);
      toast.error(t(error.error));
    }
  };
  const handleFile = (file) => {
    if (file && file.type.startsWith("image/")) {
      setImageForUpload(file);
      if (file) {
        const url = URL.createObjectURL(file);
        setPreviewUrl(url);
      }
    } else {
      toast.warn(t("only-images-allowed", "Only image files are allowed."));
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    setDragOver(false);

    handleFile(file);
  };

  const handleDragOver = (e) => {
    setDragOver(true);
    e.preventDefault();
  };

  const handleFileInputChange = (e) => {
    const file = e.target.files[0];
    handleFile(file);
  };
  const handleViewImage = (item) => {
    setImage(item);
    setEditAltText(item.alt_text);
    setEditTitle(item.title);
    setEditLegend(item.caption);
    setEditDescription(item.description);
  };
  const openFileDialog = () => fileInputRef.current.click();
  useEffect(() => {
    loadMedia();
  }, []);

  return (
    <>
      <Box
        sx={{
          position: "fixed",
          overflow: "auto",
          height: { md: "100vh", xs: "100%" },
          width: "100%",
          display: "flex",
          flexDirection: { md: "row", xs: "column" },
          mt: "44px",
          left: 0,
          top: 0,
          bgcolor: "#000000a1",
          zIndex: 9999,
        }}
      >
        <Box
          sx={{
            mx: "auto",
            mt: 4,
            bgcolor: "white",
            maxWidth: "900px",
            width: "95%",
            borderRadius: 4,
            overflow: "hidden",
            position: "relative",
            height: "80%",
          }}
        >
          {!isEdit && image && value == 1 && (
            <div className="absolute p-3 w-full bottom-0 flex justify-between items-center bg-white border-t border-slate-300">
              <div className="flex gap-3 break-all ">
                <img src={image.url} className="w-8 h-8 rounded-md" />
                <p className="text-sm">{image.file_name}</p>
              </div>
              <div className="text-end">
                <button
                  className=" font-bold text-center  p-2 px-5 rounded 
                        hover:bg-blue-200
                        hover:text-white
                       border
                       border-solid
                       border-blue-200                    
                       text-black
                         text-xs
                         "
                  onClick={() => {
                    handleSetImage(image.url);
                  }}
                >
                  {t("insert", "Insert")}
                </button>
              </div>
            </div>
          )}
          <Box
            sx={{
              px: 3,
              position: "relative",
              overflow: "hidden",
              borderBottom: "2px solid #e5e7eb",
            }}
            className="flex items-center justify-between"
          >
            <p className="text-2xl font-semibold py-3">
              {isEdit
                ? t("update-media", "Update Media")
                : t("add-media", "Add Media")}
            </p>
            <Box
              onClick={handleClose}
              sx={{
                cursor: "pointer",
              }}
            >
              <Close sx={{ color: "black", fontSize: 32 }} />
            </Box>
          </Box>
          {!isEdit && (
            <div className="mt-2 sm:mx-0 mx-2">
              <div className="sm:hidden">
                <select
                  id="tabs"
                  name="tabs"
                  value={value}
                  onChange={(e) => handleChange(e.target.value)}
                  className="block w-full bg-blue-50 text-white rounded-md border-gray-300 focus:outline-none p-2"
                >
                  {tabs.map((tab) => (
                    <option key={tab.value} value={tab.value}>
                      {tab.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="hidden sm:block">
                <nav
                  aria-label="Tabs"
                  className="isolate flex divide-x divide-gray-200 rounded-lg shadow"
                >
                  {tabs.map((tab, tabIdx) => (
                    <button
                      key={tab.value}
                      onClick={() => handleChange(tab.value)}
                      className={classNames(
                        tab.value === value
                          ? "text-blue-50 border-b border border-blue-50 hover:bg-white"
                          : "text-slate-500 hover:text-slate-700 disabled:bg-slate-200 disabled:text-slate-400",
                        tabIdx === 0 ? "rounded-l-lg" : "",
                        tabIdx === tabs.length - 1 ? "rounded-r-lg" : "",
                        "group relative min-w-0 flex-1 overflow-hidden bg-slate-100 px-4 py-4 text-center text-sm font-medium hover:bg-black/10"
                      )}
                    >
                      <span>{tab.name}</span>
                      <span
                        aria-hidden="true"
                        className={classNames(
                          tab.value === value ? "bg-blue-50" : "bg-transparent",
                          "absolute inset-x-0 bottom-0 h-0.5"
                        )}
                      />
                    </button>
                  ))}
                </nav>
              </div>
            </div>
          )}
          <div className="sm:mx-0 mx-2 h-full pb-10 ">
            {value == 1 && (
              <>
                {" "}
                <div className="flex h-full flex-col md:flex-row  items-stretch  ">
                  <div
                    className={`w-full md:w-8/12  mx-0 md:mx-2 mt-6  overflow-y-auto ${
                      image && !isEdit ? "pb-36" : "pb-24"
                    }`}
                  >
                    <>
                      {loadingMedia || deleting || updating ? (
                        <div className="text-center mt-6">
                          <CustomLoader />
                        </div>
                      ) : media.length > 0 ? (
                        <div className="flex flex-wrap items-center  gap-4">
                          {media.map((item, index) => {
                            if (!isEdit) {
                              return (
                                <div
                                  key={index}
                                  className={`lg:w-40 lg:h-40 w-32 h-32 rounded-md overflow-hidden cursor-pointer hover:opacity-85 ${
                                    image?.id === item?.id
                                      ? "border-2 border-blue-200 shadow-lg"
                                      : "border border-slate-300"
                                  }`}
                                  onClick={() => handleViewImage(item)}
                                  style={{
                                    backgroundImage: `url(${item.url})`,
                                    backgroundSize: "cover",
                                    backgroundRepeat: "no-repeat",
                                    backgroundPosition: "center",
                                  }}
                                ></div>
                              );
                            }

                            if (image && isEdit && image?.id === item?.id) {
                              return (
                                <img
                                  key={index}
                                  src={item.url}
                                  className="rounded-md border-2 border-blue-200 border-solid shadow-lg w-full"
                                />
                              );
                            }

                            return null;
                          })}
                        </div>
                      ) : (
                        <div className="text-center font-semibold text-lg">
                          {t("no-media-found", "No Media Found")}
                        </div>
                      )}
                    </>
                  </div>
                  <div
                    className={`w-full md:w-4/12 bg-slate-100/70   overflow-y-auto ${
                      isEdit ? "pb-8" : "pb-24"
                    } 
                    ${!image ? "hidden md:block" : ""}`}
                  >
                    {image && (
                      <>
                        {" "}
                        {updating ? (
                          <div className="text-center mt-6">
                            <CustomLoader />
                          </div>
                        ) : (
                          <div className="m-3 ">
                            <div className="flex gap-5 xs:gap-4">
                              <div className="w-3/12 md:w-5/12">
                                <div
                                  className="w-24 h-24 rounded-lg"
                                  style={{
                                    backgroundImage: `url(${image.url})`,
                                    backgroundSize: "cover",
                                    backgroundRepeat: "no-repeat",
                                    backgroundPosition: "center",
                                  }}
                                ></div>
                              </div>
                              <div className="">
                                <div className="flex flex-col gap-3 text-xs break-all break-words">
                                  <p>
                                    <strong>
                                      {t("file-name", "File Name")} :
                                    </strong>{" "}
                                    {image.file_name}
                                  </p>{" "}
                                  <p>
                                    <strong>{t("size", "Size")} :</strong>{" "}
                                    {image.size}
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="flex flex-col gap-3 break-words text-xs mt-3">
                              <p>
                                <strong>
                                  {t("demensions", "Dimensions")} :
                                </strong>
                                {image.dimensions}
                              </p>
                              <p>
                                <strong>
                                  {t("uploaded-on", "Uploaded on")}:
                                </strong>

                                {new Date(image.uploaded_on).toLocaleDateString(
                                  "fr-FR"
                                )}
                              </p>
                              <p>
                                <strong>{t("url", "Url")} :</strong>
                                <br />{" "}
                                <a
                                  href={image.url}
                                  target="_blank"
                                  className="text-blue-50"
                                >
                                  {image.url}
                                </a>
                              </p>
                              {!isEdit && (
                                <p
                                  className="text-red-600 cursor-pointer"
                                  onClick={() => {
                                    handleDeleteModal(true);
                                  }}
                                >
                                  <strong>
                                    {t("remove-image", "Remove Image")}
                                  </strong>
                                </p>
                              )}
                            </div>
                            <div className="flex flex-col gap-3 break-words text-xs mt-3 pt-3  pb-5  border-t border-slate-500">
                              <div>
                                <p className="mb-2">
                                  <strong>{t("alt-text", "Alt Text")}</strong>
                                </p>
                                <textarea
                                  rows={4}
                                  maxLength={150}
                                  className="border border-black p-3 w-full rounded-lg"
                                  value={editAltText}
                                  onChange={(e) => {
                                    setEditAltText(e.target.value);
                                  }}
                                ></textarea>
                              </div>

                              {!isEdit && (
                                <div>
                                  <p className="mb-2">
                                    <strong>{t("title", "Title")}</strong>
                                  </p>
                                  <input
                                    type="text"
                                    maxLength={30}
                                    className="border border-black p-3 w-full rounded-lg"
                                    value={editTitle}
                                    onChange={(e) => {
                                      setEditTitle(e.target.value);
                                    }}
                                  ></input>
                                </div>
                              )}
                              <div>
                                <p className="mb-2">
                                  <strong>{t("legend", "Legend")}</strong>
                                </p>
                                <input
                                  type="text"
                                  maxLength={50}
                                  className="border border-black p-3 w-full rounded-lg"
                                  value={editLegend}
                                  onChange={(e) => {
                                    setEditLegend(e.target.value);
                                  }}
                                ></input>
                              </div>
                              {!isEdit && (
                                <div>
                                  <p className="mb-2">
                                    <strong>
                                      {t("description", "description")}
                                    </strong>
                                  </p>
                                  <textarea
                                    rows={4}
                                    maxLength={150}
                                    className="border border-black p-3 w-full rounded-lg"
                                    value={editDescription}
                                    onChange={(e) => {
                                      setEditDescription(e.target.value);
                                    }}
                                  ></textarea>
                                </div>
                              )}
                              <div className="flex items-center justify-end gap-2 w-full mb-6 ">
                                <button
                                  className=" font-bold text-center  p-2 px-5 rounded 
                        bg-blue-200
                        text-white
                       hover:bg-blue-100
                         text-xs
                         "
                                  onClick={handleUpdate}
                                >
                                  {t("update", "Update")}
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </>
            )}

            {value == 2 && (
              <>
                {" "}
                <div className="flex gap-4 mx-2  h-full flex-col md:flex-row  items-start  ">
                  {!uploading && !imageUploading ? (
                    <>
                      <div className="w-[98%] md:w-8/12  h-full  overflow-auto mt-6 ">
                        <>
                          {previewUrl ? (
                            <div className=" rounded-md border w-full  border-slate-300 relative z-10 ">
                              <div
                                onClick={() => {
                                  setPreviewUrl(null);
                                  setImageForUpload(null);
                                }}
                                className="absolute end-0 top-0 cursor-pointer w-5 h-5 bg-black rounded-full flex items-center justify-center"
                              >
                                <Close sx={{ color: "white", fontSize: 18 }} />
                              </div>

                              <img
                                src={previewUrl}
                                className="w-full rounded-md"
                              />
                            </div>
                          ) : (
                            <>
                              <div
                                onDrop={handleDrop}
                                onDragOver={handleDragOver}
                                onClick={openFileDialog}
                                style={{
                                  border: `2px dashed ${
                                    dragOver ? "#999" : "#ccc"
                                  }`,
                                  borderRadius: "12px",
                                  padding: "40px",
                                  textAlign: "center",
                                  cursor: "pointer",
                                  background: "#fafafa",
                                  height: "150px",
                                }}
                                className="flex flex-col justify-center items-center"
                              >
                                <p>
                                  {t(
                                    "drag-files",
                                    "Drag & drop files here, or click to select"
                                  )}
                                </p>
                                <input
                                  ref={fileInputRef}
                                  type="file"
                                  accept="image/*"
                                  onChange={handleFileInputChange}
                                  style={{ display: "none" }}
                                />
                              </div>
                            </>
                          )}
                        </>
                      </div>
                      <div
                        className={`w-[98%]  md:w-4/12  h-full  overflow-auto ${
                          seoOptimization ? "pb-32" : "pb-24"
                        }`}
                      >
                        <div className="   w-full border   my-6 rounded-md border-slate-300">
                          <div className="m-3 text-sm">
                            {" "}
                            <div className="flex items-center gap-2  mt-3">
                              {t("seo-optimizations?", "SEO optimizations?")}
                              <FormControlLabel
                                control={
                                  <Switch
                                    checked={seoOptimization}
                                    onChange={(e) => {
                                      setSeoOptimization(e.target.checked);
                                    }}
                                  />
                                }
                              />
                            </div>
                          </div>
                          {seoOptimization && (
                            <>
                              <div className="m-3 border-t border-slate-300 pt-3 text-sm">
                                {" "}
                                <p className="text-black font-semibold text-lg">
                                  {t(
                                    "text-optimizations",
                                    "Text Optimizations"
                                  )}
                                </p>
                                <div className="flex items-center gap-2 mt-3">
                                  <input
                                    type="checkbox"
                                    checked={genFileName}
                                    onChange={(e) => {
                                      setGenFileName(e.target.checked);
                                    }}
                                  />
                                  {t(
                                    "generate-file-name",
                                    "Generate file name"
                                  )}
                                </div>
                                <div className="flex items-center gap-2  mt-3">
                                  <input
                                    type="checkbox"
                                    checked={genAltText}
                                    onChange={(e) => {
                                      setGenAltText(e.target.checked);
                                    }}
                                  />
                                  {t("generate-alt-text", " Generate alt text")}
                                </div>
                                <div className="flex items-center gap-2  mt-3">
                                  <input
                                    type="checkbox"
                                    checked={genLegend}
                                    onChange={(e) => {
                                      setGenLegend(e.target.checked);
                                    }}
                                  />
                                  {t("generate-legend", "Generate legend")}
                                </div>
                                <div className="flex items-start flex-col gap-2  mt-3">
                                  <p>
                                    <strong>
                                      {t("about-img", "About Image")}
                                    </strong>
                                  </p>
                                  <textarea
                                    rows={4}
                                    maxLength={150}
                                    className="border border-black p-3 w-full rounded-lg"
                                    value={aboutImg}
                                    onChange={(e) => {
                                      setAboutImg(e.target.value);
                                    }}
                                  ></textarea>
                                </div>
                              </div>
                              <div className="m-3 border-t border-slate-300 pt-3 text-sm">
                                {" "}
                                <p className="text-black font-semibold text-lg">
                                  {t(
                                    "file-optimizations",
                                    "File Optimizations"
                                  )}
                                </p>
                                <div className="flex items-center gap-2 mt-3">
                                  <input
                                    type="checkbox"
                                    checked={compressImage}
                                    onChange={(e) => {
                                      setCompressImage(e.target.checked);
                                    }}
                                  />
                                  {t("compress-image", "Compress image")}
                                </div>
                                <div className="flex items-center gap-2  mt-3">
                                  <input
                                    type="checkbox"
                                    checked={hasImageSize}
                                    onChange={(e) => {
                                      setHasImageSize(e.target.checked);
                                    }}
                                  />
                                  {t("convert-image-to", "Convert image to")}{" "}
                                  <input
                                    type="number"
                                    min={0}
                                    value={imageSize}
                                    onChange={(e) => {
                                      setImageSize(e.target.value);
                                    }}
                                    className="rounded-md px-1 w-14 h-6 border border-black"
                                  />{" "}
                                  {t("px", "px")}
                                </div>
                                <div className="flex items-center gap-2  mt-3">
                                  <input
                                    type="checkbox"
                                    checked={toWebp}
                                    onChange={(e) => {
                                      setToWebp(e.target.checked);
                                    }}
                                  />
                                  {t("convert-to-webp", "Convert to webp")}
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                        {imageForUpload && (
                          <div className="text-end w-full mb-3 ">
                            <button
                              className=" font-bold text-center  p-2 px-5 rounded 
                        bg-blue-200
                        text-white
                       hover:bg-blue-100
                         text-xs
                         "
                              onClick={handleUpload}
                            >
                              {t("upload", "Upload")}
                            </button>
                          </div>
                        )}
                      </div>
                    </>
                  ) : (
                    <div className="text-center w-full flex flex-col h-3/4 justify-center items-center mt-3">
                      <CustomLoader></CustomLoader>
                      <p>
                        {uploadingState
                          ? t(uploadingState)
                          : `${t("uploading", "uploading")}....`}
                      </p>
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </Box>
      </Box>

      <Dialog
        open={open}
        onClose={() => handleDeleteModal(false)}
        className="relative z-[10000]"
      >
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />
        <div className="fixed inset-0 z-[999] w-screen overflow-y-auto bg-black/50">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <DialogPanel
              transition
              className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:w-full sm:max-w-2xl sm:p-8 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
            >
              <div className="">
                <DialogTitle
                  as="h3"
                  className="text-base font-semibold leading-6 text-gray-900"
                >
                  <div className="flex items-center gap-3">
                    <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-error/30 sm:mx-0 sm:h-10 sm:w-10">
                      <PriorityHigh
                        aria-hidden="true"
                        className="h-8 w-8 text-error"
                      />
                    </div>
                    <p className="text-base font-semibold leading-6 text-black/40">
                      {t("delete-image", "Delete image")}
                    </p>
                  </div>
                </DialogTitle>
                <p className="text-base text-black text-left mt-5">
                  {t(
                    "are-you-sure-to-delete-image",
                    "Are you sure you want to delete this image? Image will be deleted and you won't be able to recover it."
                  )}{" "}
                </p>
                <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                  <button
                    type="button"
                    onClick={() => handleDeleteImage()}
                    className="inline-flex w-full justify-center rounded-md bg-error px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
                  >
                    {" "}
                    {t("delete", "Delete")}
                  </button>
                  <button
                    type="button"
                    data-autofocus
                    onClick={() => handleDeleteModal(false)}
                    className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                  >
                    {" "}
                    {t("cancel", "Cancel")}
                  </button>
                </div>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </>
  );
};
